import {
  FilterId,
  GenericFilterOption,
  SearchFilterType,
  SearchNavBarSections,
} from '../../types/filters/filters';
import { FilterQueryParam } from '../../types/search/search';

interface GetCollectionFilterConfigInputs {
  options?: GenericFilterOption[];
}

export const getCollectionFilterConfig = (params?: GetCollectionFilterConfigInputs) => {
  const { options = [] } = params || {};
  return {
    id: FilterId.Collection,
    label: 'Collection',
    type: SearchFilterType.Checkbox,
    group: 'primary',
    queryParamNames: [FilterQueryParam.collection],
    searchNavBarSection: SearchNavBarSections.Filter,
    config: { options },
  };
};
